export enum TaskTypeEnum {
  ProcessarArrecadacao = "processarArrecadacao",
}

export interface TaskResponse {
  id: string;
  type: TaskTypeEnum;
  title: string;
  createdAt: number;
  finishDate: number | null;
  errors: {
    message: string;
    context: any;
  }[];
}
